import React, { useEffect, useState, useCallback } from 'react';
import { Coins } from 'lucide-react';
import { Link } from 'react-router-dom';
import { authFetch } from '../utils/authUtils';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Persistent coin badge for the app header.
 * - Fetches balance on mount.
 * - Refreshes on `coins-changed` and `theme-changed` window events.
 * - Click navigates to the full /shop page (replaces the old modal popup).
 */
const HeaderCoinBadge = () => {
  const [coins, setCoins] = useState(null);

  const load = useCallback(async () => {
    try {
      const res = await authFetch(`${BACKEND_URL}/api/gamification/me`);
      if (!res.ok) return;
      const d = await res.json();
      setCoins(d?.coins ?? 0);
    } catch (_) {
      // silent
    }
  }, []);

  useEffect(() => {
    load();
    const refresh = () => load();
    window.addEventListener('coins-changed', refresh);
    window.addEventListener('theme-changed', refresh);
    return () => {
      window.removeEventListener('coins-changed', refresh);
      window.removeEventListener('theme-changed', refresh);
    };
  }, [load]);

  if (coins === null) return null;

  return (
    <Link
      to="/shop"
      className="flex items-center gap-1.5 px-3 py-1 bg-amber-900/40 border border-amber-700/50 rounded-full hover:bg-amber-900/60 hover:border-amber-500/70 transition-colors cursor-pointer"
      title="Open Coin Shop"
      data-testid="header-coin-badge"
    >
      <Coins className="w-4 h-4 text-amber-300" />
      <span className="text-sm font-bold text-amber-200">{coins}</span>
    </Link>
  );
};

export default HeaderCoinBadge;
